@if (unread > 0) {
  <div class="unread-badge" data-cy="unread-document-badge">
    <span class="m-auto">{{ unread }}</span>
  </div>
}
